/** Shared BUI-92/BUI-154 write/read contract for judgment tags. */
export const PHASE_OPTIONS = [
  { id: "0", label: "0 · Contract & Permitting" },
  { id: "1", label: "1 · Site Prep & Excavation" },
  { id: "2", label: "2 · Foundation" },
  { id: "3", label: "3 · Frame" },
  { id: "4", label: "4 · Dry-in / Envelope" },
  { id: "5", label: "5 · Rough-in / MEP" },
  { id: "6", label: "6 · Insulation & Drywall" },
  { id: "7", label: "7 · Interior Finish" },
  { id: "8", label: "8 · Exterior Finish, Site & Landscape" },
  { id: "9", label: "9 · Closeout" },
] as const;

export interface TaggedReadFilter {
  phase?: string;
  trade?: string;
}

export function matchesTaggedReadFilter(
  value: { phase?: string; trade?: string },
  filter: TaggedReadFilter,
): boolean {
  return (filter.phase === undefined || value.phase === filter.phase)
    && (filter.trade === undefined || value.trade === filter.trade);
}

export function presentPhases(values: readonly { phase?: string }[]) {
  const present = new Set(values.map((value) => value.phase).filter((phase): phase is string => !!phase));
  return PHASE_OPTIONS.filter((option) => present.has(option.id));
}

export function presentTrades(values: readonly { trade?: string }[]): string[] {
  return Array.from(new Set(values.map((value) => value.trade).filter((trade): trade is string => !!trade)));
}
